module.exports = __webpack_public_path__ + "img/collage.210f2082.png";